<script lang="ts">
    import type * as t from "./types";

    import Confetti from "svelte-confetti";
    import { capitalizeFirstLetter, getPrizeText } from "./utils";

    export let prize: t.SegmentConfig["prize"];
    export let stepsCount;
    export let currentStep;

    let prizeText = getPrizeText(prize);
    prizeText = capitalizeFirstLetter(prizeText);

    $: percent = ((currentStep + 1) / stepsCount) * 100;
    $: barWidth = `${percent}%`;
</script>

<div class="background w-full rounded-full">
    <div
        class="
    foreground progress-width
    flex justify-center rounded-full px-3
    py-1.5
    transition-[width]
    "
        class:font-semibold={percent >= 100}
        style="
        --progress-width:{barWidth};
    "
    >
        {#if percent >= 100}
            <div class="relative text-sm font-semibold sm:text-base">
                <span>
                    🎉 You've earned {prizeText}! 🎉
                </span>
                <div class="absolute inset-0 flex w-full justify-center">
                    <Confetti cone delay={[0, 250]} />
                </div>
            </div>
        {/if}
    </div>
</div>
<div class="mt-2 flex justify-center">
    {#if currentStep + 1 < stepsCount}
        {currentStep + 1}/{stepsCount} steps away from {prizeText}
    {/if}
</div>

<style>
    .background {
        background-color: var(--secondary-color);
    }

    .foreground {
        background-color: var(--accent-color);
        color: var(--secondary-color);
    }

    .progress-width {
        width: var(--progress-width);
    }
</style>
